import { createSlice } from '@reduxjs/toolkit';

import { Client } from 'entities/Client';
import { Invoice } from 'entities/Invoice';
import { AppError } from 'entities/Errors';

import {
  getClientInvoiceList,
  getClientList,
  getClientInvoice,
  updateClientInvoice,
  updateClient,
} from './client.action';

interface ClientState {
  loading: boolean;
  error: null | AppError;
  list: Client[];
  invoiceList: Invoice[];
  invoice: Invoice | null;
}

const initialState = {
  loading: false,
  error: null,
  list: [],
  invoiceList: [],
  invoice: null,
} as ClientState;

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClientList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.list = [];
      })
      .addCase(getClientList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
      })
      .addCase(getClientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      })
      .addCase(getClientInvoiceList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.invoiceList = [];
      })
      .addCase(getClientInvoiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.invoiceList = action.payload.data;
      })
      .addCase(getClientInvoiceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      })
      .addCase(getClientInvoice.pending, (state) => {
        state.loading = true;
        state.invoice = null;
        state.error = null;
      })
      .addCase(getClientInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload.data;
      })
      .addCase(getClientInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      })
      .addCase(updateClientInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClientInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload.data;
      })
      .addCase(updateClientInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      })
      .addCase(updateClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClient.fulfilled, (state, action) => {
        state.loading = false;
        const newList = state.list.filter(
          (x) => x.id !== action.payload.data.id
        );

        state.list = [...newList, action.payload.data];
      })
      .addCase(updateClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default clientSlice.reducer;
